import React from "react";
import { useParams, Redirect } from "react-router-dom";
import MainContainer from "../../components/MainContainer";
import TicketConfigurationPage from "./TicketConfigurationPage";
import TicketPublicoPage from "./TicketPublicoPage";
import KanbanSuportePage from "./KanbanSuportePage";

/** Mapeia segmento da URL para chave em ticketPanelConfig.subMenus */
const SECTION_TO_I18N = {
  configuracao: "configuracao",
  "kanban-suporte": "kanbanSuporte",
  "ticket-publico": "ticketPublico",
};

export const PainelTicketRedirect = () => (
  <Redirect to="/painel-ticket/ticket-publico" />
);

/** URLs antigas com "visao-geral" redirecionam para Ticket público */
export const PainelTicketLegacyVisaoRedirect = () => (
  <Redirect to="/painel-ticket/ticket-publico" />
);

const TicketPanelConfig = () => {
  const { section } = useParams();
  const subKey = SECTION_TO_I18N[section];

  if (!subKey) {
    return <Redirect to="/painel-ticket/ticket-publico" />;
  }

  return (
    <MainContainer>
      {section === "configuracao" ? <TicketConfigurationPage /> : null}
      {section === "kanban-suporte" ? <KanbanSuportePage /> : null}
      {section === "ticket-publico" ? <TicketPublicoPage /> : null}
    </MainContainer>
  );
};

export default TicketPanelConfig;
